import React from 'react'

import {
  Card,
  Typography,
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@material-ui/core'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'
import { useDispatch, useSelector } from 'react-redux'
import RefreshIcon from '@material-ui/icons/Refresh'

import { Button } from 'semantic-ui-react'
import styles from '../settingsStyles'
import Loading from '../../dashboard/widgets/helpers/Loading'

import {
  fetchAuthorizedUsers,
  selectAuthorizedDevices,
  deleteDevice,
  selectDevicesStatus,
  deleteDeviceStatus,
} from '../settingsSlice'
import PageLink from '../components/PageLink'
import { trackEvent } from '../../../helpers/analytics'
import useSettingsBack from '../../../helpers/useSettingsBack'
import BackButtonNavBar from '../../../CommonComponents/BackButtonNavBar/BackButtonNavBar'

function DeviceManagement() {
  const classes = styles()
  const authorizedDevices = useSelector(selectAuthorizedDevices)
  const status = useSelector(selectDevicesStatus)
  const deleteStatus = useSelector(deleteDeviceStatus)
  const goBackButton = useSettingsBack('DeviceManagement', '/settings')
  const dispatch = useDispatch()
  const [open, setOpen] = React.useState(false)
  const [target, setTarget] = React.useState(null)

  const handleDelete = (deviceID) => {
    trackEvent(dispatch, {
      eventName: 'uxp_settings_item_click',
      module: 'Settings',
      object: 'DeviceManagement',
      action: 'Click',
      actionContext: 'DeviceManagement',
      actionContextValue: 'DeleteDevice',
    })
    setOpen(false)
    dispatch(deleteDevice(deviceID))
  }

  const refresh = () => {
    trackEvent(dispatch, {
      eventName: 'uxp_settings_item_click',
      module: 'Settings',
      object: 'DeviceManagement',
      action: 'Click',
      actionContext: 'DeviceManagement',
      actionContextValue: 'Refresh',
    })
    dispatch(fetchAuthorizedUsers())
  }

  const handleDialogOpen = (deviceID) => {
    trackEvent(dispatch, {
      eventName: 'uxp_settings_item_click',
      module: 'Settings',
      object: 'DeviceManagement',
      action: 'Click',
      actionContext: 'DeviceManagement',
      actionContextValue: 'OpenDeleteDeviceDialog',
    })
    setTarget(deviceID)
    setOpen(true)
  }

  React.useEffect(() => {
    if (deleteStatus === 'fulfilled') {
      dispatch(fetchAuthorizedUsers())
    }
  }, [deleteStatus])

  React.useEffect(() => {
    dispatch(fetchAuthorizedUsers())
  }, [])

  return (
    <Box className={classes.settingsNavBar}>
      <BackButtonNavBar
        onClick={goBackButton}
        name="Device Management"
        topMargin={{ xs: 56, sm: 64, md: 64, lg: 64 }}
      />
      <Box className={classes.centerPage}>
        <Grid
          container
          direction="column"
          alignItems="center"
          className={classes.container}
          wrap="nowrap"
        >
          <IconButton
            onClick={refresh}
            size="small"
            className={classes.refreshButton}
            aria-label="Refresh devices"
            style={{ marginLeft: 'auto' }}
          >
            <RefreshIcon />
          </IconButton>
          <Grid item className={classes.fullWidth}>
            {status === 'fulfilled' ? (
              <DevicesList
                authorizedDevices={authorizedDevices}
                dialogTarget={handleDialogOpen}
                classes={classes}
              />
            ) : (
              <Loading />
            )}
          </Grid>
          <Dialog open={open}>
            <DialogTitle>
              <Typography variant="h5">Confirm Delete</Typography>
            </DialogTitle>
            <DialogContent>
              <Typography>
                Are you sure you want to delete this device?
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => handleDelete(target)}>
                Delete Device
              </Button>
              <Button
                onClick={() => {
                  trackEvent(dispatch, {
                    eventName: 'uxp_settings_item_click',
                    module: 'Settings',
                    object: 'DeviceManagement',
                    action: 'Click',
                    actionContext: 'DeviceManagement',
                    actionContextValue: 'KeepDevice',
                  })
                  setOpen(false)
                }}
              >
                Keep Device
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
      </Box>
    </Box>
  )
}
const DevicesList = ({ authorizedDevices, dialogTarget, classes }) => (
  <Card className={classes.linksCard}>
    {authorizedDevices && authorizedDevices.devices.length !== 0 ? (
      authorizedDevices.devices.map((device) => (
        <PageLink
          key={device.ID}
          title={device.Device}
          description={
            <>
              {device.biometric ? (
                <CheckCircleIcon
                  style={{
                    color: 'green',
                    verticalAlign: 'middle',
                    marginRight: 5,
                  }}
                />
              ) : (
                <CancelIcon
                  style={{
                    color: 'red',
                    verticalAlign: 'middle',
                    marginRight: 5,
                  }}
                />
              )}
              Biometrics are {device.biometric ? '' : 'not'} enabled on{' '}
              {device.DeviceType} device
            </>
          }
          icon={
            <IconButton onClick={() => dialogTarget(device.ID)}>
              <DeleteForeverIcon />
            </IconButton>
          }
          section="DeviceManagement"
        />
      ))
    ) : (
      <PageLink
        title="No devices"
        description="You currently have no devices"
        icon={null}
        section="DeviceManagement"
      />
    )}
  </Card>
)

export default DeviceManagement
